import { render } from "./UserLayout.vue?vue&type=template&id=2243d0b8&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"

import "./UserLayout.vue?vue&type=style&index=0&id=2243d0b8&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2243d0b8"]])

export default __exports__